import { Skeleton } from '@repo/videa-components/src/index';

const SKELETON_CLASS = 'vai-h-10 vai-w-full vai-bg-gray-300/70';

export const VideaUserInformationFormSkeleton = () => {
  return (
    <div className="vai-space-y-8 vai-flex vai-flex-col vai-justify-center">
      <div className="vai-space-y-2">
        <Skeleton className={SKELETON_CLASS} />
      </div>
      <div className="vai-grid vai-grid-cols-2 vai-gap-4">
        <div className="vai-space-y-2">
          <Skeleton className={SKELETON_CLASS} />
        </div>
        <div className="vai-space-y-2">
          <Skeleton className={SKELETON_CLASS} />
        </div>
      </div>
      <div className="vai-grid vai-grid-cols-2 vai-gap-4">
        <div className="vai-space-y-2">
          <Skeleton className={SKELETON_CLASS} />
        </div>
        <div className="vai-space-y-2">
          <Skeleton className={SKELETON_CLASS} />
        </div>
      </div>
      <div className="vai-space-y-2">
        <Skeleton className={SKELETON_CLASS} />
      </div>
      <div className="vai-space-y-2">
        <Skeleton className={SKELETON_CLASS} />
      </div>
      <div className="vai-space-y-2">
        <Skeleton className={SKELETON_CLASS} />
      </div>
    </div>
  );
};
